<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-content">
        <div @click="openHerderImg()" class="item van-hairline--bottom">
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img  :src="this.userInfo.header_img">
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="show" position="bottom" round :style="{ height: '48%' }">
            <div class="avatarbox">
                <div class="title">
                  <van-icon @click="show=false" name="cross" />
                  <div class="text">Select avatar</div>
                  <div class="btnok" @click="check()">Sure</div>
                </div>
                <div class="content">
                  <div
                      class="avatar-item"
                      v-for="(item,index) in 20" :key="index"
                      @click="select_header_img('/img/head/'+(index+1)+'.png')"
                      :class="{ 'choose': isActive ===  '/img/head/'+(index+1)+'.png'}"
                  >
                    <img :src="'/img/head/'+(index+1)+'.png'" />
                  </div>
                </div>
                <div class="bottom-btn">
                  <van-button block @click="check()" class="confirm-btn">Avatar</van-button>
                </div>
            </div>
        </van-popup>
        <div class="item van-hairline--bottom" @click="toSetName()">
        <div class="left">{{$t("setting.real_name")}}</div>
        <div class="right">
          <span>{{this.userInfo.name ? this.userInfo.name : this.$t("setting.no_setting")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetSex()">
        <div class="left">{{$t("setting.sex")}}</div>
        <div class="right">
          <span>{{this.userInfo.sex !== "0" ? this.userInfo.sex === "1" ? this.$t("setting.man") :this.$t("setting.female"): this.$t("setting.unkown")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetBank()">
        <div class="left">{{$t("setting.bind_bank_info")}}</div>
        <div class="right">
          <!-- <span>{{this.isBank ? this.$t("setting.bindinged") :this.$t("setting.no")}}</span> -->
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'post',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.page{
  background-color: #fff !important;
}
.container .main-content {
  padding: 0 .4rem;
  background-color: #fff;
}
.container .main-content .item{
  padding: .46667rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: .34667rem;
  color: #000;
}
.container .main-content .item .right .desc {
  font-size: 0.34667rem;
  font-weight: 700;
  color: #979799;
}
.container .main-content .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container .main-content .item .right span{
  font-size: 0.4rem;
  font-weight: 700;
  color: #979799;
}
.container .main-content .item .right img{
  width: 0.9rem;
}
.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 0.03rem;
}
.container .main-content .item .right .desc-cell-number, .container .main-content .item .right .desc{
  font-size: 0.3rem;
  font-weight: 700;
  color: #979799;
}
.avatarbox{
  padding: 0.4rem 0.3rem;
  color: #000;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.avatarbox .title{
  padding: 0 0 0.3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.4rem;
  font-weight: 500;
}

.avatarbox .title .text {
  flex: 1;
  text-align: center;
  font-size: 0.42rem;
  font-weight: 400;
}

.avatarbox .title .van-icon {
  font-size: 0.5rem;
  color: #666;
}

.avatarbox .title .btnok {
  font-size: 0.37333rem;
  color: #000;
}

.avatarbox .content .avatar-item{
  width: 1.4rem;
  height: 1.4rem;
  margin: 0.05rem 0.1rem;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}

.avatarbox .content .avatar-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.avatarbox .content{
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0.1rem 0.2rem;
}
.avatarbox .content .choose{
  border: 0.08rem solid #7c5ff5;
  box-shadow: 0 0 0.2rem rgba(124, 95, 245, 0.5);
}

.avatarbox .bottom-btn {
  padding-top: 0.4rem;
}

.avatarbox .confirm-btn {
  height: 1.2rem;
  border-radius: 0.6rem;
  background: linear-gradient(90deg, #7c5ff5, #5b47f5);
  color: #fff;
  font-size: 0.4rem;
  font-weight: 600;
  border: none;
}

::v-deep .confirm-btn .van-button__text {
  color: #fff;
}
.nav-bar{
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #000;
  font-size: 0.48rem;
  font-weight: 500;
}

::v-deep .van-icon-arrow-left {
  color: #666 !important;
  font-size: 0.6rem !important;
}
</style>
